<template>
    <div class="align-center">
        <div class="mb-4">
            <table-view-job by="6" title="Acceptance/Preliminary"></table-view-job>
        </div>
        <div class="mb-4">
            <table-view :future="true" by="maintain" title="Maintain Expired"></table-view>
        </div>
        <div class="mb-4">
            <table-view :future="true" by="next_maintain" title="Next Maintain"></table-view>
        </div>
        <div class="mb-4">
            <table-view :future="true" by="warranty" title="Warranty Expired"></table-view>
        </div>
        <div class="mb-4">
            <table-view
                :future="true"
                by="latest_maintain_date"
                title="Today Maintain"
                :dateInTitle="false"
                filter_date_by_1="next_maintain"
                :isToday="true"
            ></table-view>
        </div>
        <div class="mb-4">
            <table-view-job by="1" title="Sitecheck Job"></table-view-job>
        </div>
        <div class="mb-4">
            <table-view-job by="3" title="Repaired Job"></table-view-job>
        </div>
        <div class="mb-4">
            <table-view-job by="4" title="Installation Job"></table-view-job>
        </div>
        <div class="mb-4">
            <table-view-job by="2" title="Maintained Job"></table-view-job>
        </div>
        <div class="mb-4">
            <table-view-job by="7" title="Safety Assessment"></table-view-job>
        </div>
    </div>
</template>
<script>
import TableView from "../components/TableView";
import TableViewJob from "../components/TableViewJob";
export default {
    metaInfo() {
        return {
            title: "Dashboard"
        };
    },
    data: () => ({}),
    components: {
        TableView,
        TableViewJob
    },
    created() {},
    watch: {},
    methods: {}
};
</script>
<style>
table.v-table tbody td a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
}
</style>